import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
import { FeaturePageStructuredData } from "../../config/StructuredData";

const ReviewApprovalWorkflow = () => (
  <>
    <FeaturePageStructuredData
      name="Review and Approval Workflow for CA Firms"
      description="Simplifyte's maker-checker workflow ensures every piece of work is reviewed before partner approval — with a full audit trail of who reviewed what and when."
      url="https://www.simplifyte.com/features/review-approval-workflow"
    />
    <HeaderMenu />
    <main style={{ paddingTop: "80px", minHeight: "100vh" }}>
      <section style={{ background: "linear-gradient(135deg,#093A5B 0%,#0a4d6e 100%)", padding: "60px 24px", color: "#fff", textAlign: "center" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <p style={{ fontSize: "13px", letterSpacing: "2px", textTransform: "uppercase", opacity: 0.7, marginBottom: "16px" }}>Features</p>
          <h1 style={{ fontSize: "clamp(26px,4vw,44px)", fontWeight: 700, lineHeight: 1.2, marginBottom: "20px" }}>Review and Approval Workflow for CA Firms</h1>
          <p style={{ fontSize: "17px", opacity: 0.85, maxWidth: "640px", margin: "0 auto 32px" }}>Staff prepares → reviewer checks → partner approves. Every step logged. Nothing moves forward without the right sign-off.</p>
          <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "12px 28px", borderRadius: "8px", fontWeight: 600, textDecoration: "none" }}>Book a Demo</Link>
        </div>
      </section>

      <section style={{ padding: "60px 24px" }}>
        <div style={{ maxWidth: "820px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "26px", fontWeight: 700, color: "#093A5B", marginBottom: "16px" }}>Maker-checker workflow built for professional service firms</h2>
          <p style={{ fontSize: "16px", color: "#475569", lineHeight: 1.7, marginBottom: "16px" }}>
            In CA firms, work must pass through review before it reaches the partner or client. A junior prepares a return, a senior reviews it, the partner approves it. This is the maker-checker model — and it is the standard in professional services.
          </p>
          <p style={{ fontSize: "16px", color: "#475569", lineHeight: 1.7 }}>
            Without a structured system, review happens over WhatsApp, email, or verbal confirmation — with no record of what was reviewed, what comments were given, or who approved. Simplifyte makes every step of this process explicit, logged, and traceable.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: "16px", marginTop: "32px" }}>
            {["Defined review and approval stages","Reviewer comments logged on the work item","Partner approval required before closure","Return-to-staff workflow for rework","Full audit trail of every review decision"].map((t,i)=>(
              <div key={i} style={{ background: "#f8fafc", padding: "16px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "14px", color: "#475569" }}>✓ {t}</div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: "40px 24px", background: "#f8fafc" }}>
        <div style={{ maxWidth: "820px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "24px", fontWeight: 700, color: "#093A5B", marginBottom: "24px" }}>Before Simplifyte / With Simplifyte</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            <div style={{ background: "#fff5f5", padding: "20px", borderRadius: "10px" }}>
              <h3 style={{ color: "#ef4444", marginBottom: "12px", fontSize: "15px", fontWeight: 600 }}>Before Simplifyte</h3>
              {["Review done on WhatsApp or verbal","No record of what reviewer checked","Partner approval is a casual 'ok'","Rework instructions lost in chat","No way to prove what was reviewed and when"].map((t,i)=>(<p key={i} style={{ fontSize: "14px", color: "#64748b", marginBottom: "8px", paddingLeft: "8px", borderLeft: "2px solid #fca5a5" }}>{t}</p>))}
            </div>
            <div style={{ background: "#f0fdf4", padding: "20px", borderRadius: "10px" }}>
              <h3 style={{ color: "#16a34a", marginBottom: "12px", fontSize: "15px", fontWeight: 600 }}>With Simplifyte</h3>
              {["Review stage is a system step with a log","Reviewer comments visible on the work item","Partner approval is a click — with a timestamp","Rework returns to staff with specific notes","Audit trail shows every review and who did it"].map((t,i)=>(<p key={i} style={{ fontSize: "14px", color: "#64748b", marginBottom: "8px", paddingLeft: "8px", borderLeft: "2px solid #86efac" }}>{t}</p>))}
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: "60px 24px", textAlign: "center", background: "#093A5B", color: "#fff" }}>
        <h2 style={{ fontSize: "26px", fontWeight: 700, marginBottom: "14px" }}>Make every review and approval accountable</h2>
        <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "13px 30px", borderRadius: "8px", fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "8px" }}>Book a Demo <ArrowRight size={16} /></Link>
      </section>
    </main>
    <CustomFooter />
  </>
);

export default ReviewApprovalWorkflow;
